import React, { useContext } from 'react';
import { MeshStatus } from '../../../generated/src/models';
import { getMeshBoundaries } from '../../app/apiFunctions';
import { IGlobalContext } from '../../app/AppWrapper';
import { GlobalContext } from '../../../store/Store';
import { StyledSelect } from '../StyledSelect';

export default function SelectModelArea() {
  // global store
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const globalContext: IGlobalContext = { state: globalState, dispatch: globalDispatch };
  const modelAreas: MeshStatus[] = globalState.meshFilesImported || [];
  // console.log('modelAreas', modelAreas);

/*   const onSelectClick = e => {
    // console.log('onSelectClick', e);
    getListMeshStatus({ globalContext });
  };
  const isMeshSelected = (mesh: string): boolean => {
    return mesh === globalState.mesh.meshName;
  }; */
  const onMeshChange = (e: React.ChangeEvent<{ value: string }>) => {
    // console.log(e.target.value, e);
    if (e.target.value === globalState.mesh.meshName) {
      return;
    }
    getMeshBoundaries({
      meshName: e.target.value,
      globalContext,
    });
  };

  return (
    <>
{/*       <Select
        value={globalState.mesh.meshName}
        disabled={modelAreas.length > 0 ? false : true}
        input={<Input id="mesh-selector" />}
        onClick={onSelectClick}
        onChange={() => onMeshChange}>
        {modelAreas &&
          modelAreas.map(
            (mf, i) =>
              mf.hasBoundariesExtracted && (
                <MenuItem key={i} value={mf.meshName} selected={isMeshSelected(mf.meshName)}>
                  {mf.meshName}
                </MenuItem>
              )
          )}
      </Select> */}
      <StyledSelect 
        label={"Select model area"}            
        fullWidth={true}
        name={globalState.mesh.meshName}
        value={globalState.mesh.meshName}         
        valueField={"meshName"}
        primaryField={"meshName"}
        items={modelAreas.filter(ma => ma.hasBoundariesExtracted)}
        onChange={(event: React.ChangeEvent<{value: string}>) => onMeshChange(event)}
        disabled={modelAreas.length > 0 ? false : true} 
        helperText={modelAreas.length === 0 ? "No mesh imported" : ""}      
      />     
      {/* {modelAreas.length === 0 ? <FormHelperText>No mesh imported</FormHelperText> : null} */}
    </>
  );
}
